export const JSON_SCHEMA_ON_SUBMIT = 'onSubmit'
export const JSON_SCHEMA_ON_CHANGE = 'onChange'
export const JSON_SCHEMA_CONDITIONALS = 'conditionals'

export const CONDITIONAL_ACTION_TYPE_SUBMIT = 'submit'
export const CONDITIONAL_ACTION_TYPE_FLOW = 'goToFlow'
export const CONDITIONAL_ACTION_TYPE_DIALOG = 'launchDialog'
